import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "none",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 18,
		height: 18,
		rx: 9,
		fill: "var(--color-gray-200)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.03393 5.56993L8.99684 8.53066L11.9283 5.59966C12.1281 5.42174 12.3348 5.52797 12.4174 5.61714C12.4704 5.68172 12.4978 5.76357 12.4942 5.84703C12.4907 5.9305 12.4565 6.00973 12.3982 6.06958L9.46633 9.00015L12.3982 11.9298C12.5285 12.0391 12.5285 12.2533 12.424 12.3731C12.3191 12.4924 12.1267 12.5615 11.9453 12.4199L8.99684 9.46963L6.04486 12.4212C5.91546 12.537 5.70214 12.5134 5.59679 12.3985C5.491 12.283 5.45079 12.0837 5.58586 11.943L8.52736 9.00015L5.5981 6.06958C5.491 5.95155 5.45385 5.73561 5.5981 5.59966C5.74236 5.46371 5.95743 5.4825 6.03393 5.56993Z",
		fill: "currentColor"
	})]
});
export default SvgClear;
